import type { Branded } from '@/utils/typing/branded.type';
import type { ClassificationNodeId } from '../../interfaces/Classification.interface';
import type { RunFrequency } from '../../interfaces/run-frequency.interface';

export type ReportPlanId = Branded<number, 'ReportPlanId'>;

export interface ReportPlan {
    reportPlanId: ReportPlanId;
    reportTypeCode: string;
    classificationNodeId: ClassificationNodeId;
    classificationNodeName: string;
    numberOfLeaves: number;
    periodCode: string;
    enableEstimated: boolean;
    runFrequency: RunFrequency;
    isActive: boolean;
    lastRunDate: string;
    createdBy: string;
    creationDate: string;
    files: ReportFile[];
    subscriptions: ReportSubscription[];
    emailSubject: string;
    emailBody: string;
    generationType: ReportGenerationType;
}

export interface ReportFile {
    reportPlanId: ReportPlanId;
    runDate: string;
    fileUrl: string;
    expirationDate: string;
}

export interface RequestPlanSaveBody {
    reportTypeCode: string;
    classificationNodeId: ClassificationNodeId;
    periodCode: string;
    enableEstimated: boolean;
    runFrequency: RunFrequency;
    emailSubject: string;
    emailBody: string;
    generationType: ReportGenerationType;
}

export interface RequestPlanCreationBody extends RequestPlanSaveBody {
    recipientsEmails: string[];
}

export interface RequestPlanUpdateBody extends RequestPlanSaveBody {
    reportPlanId: ReportPlanId;
}

export interface ReportSubscription {
    reportPlanId: number;
    email: string;
    isActive: boolean;
    lastUpdateDate: string;
    lastSentDate: string;
}

export enum ReportGenerationType {
    LEGACY = 'legacy_dashboard',
    TAILORED_DASHBOARD = 'tailored_dashboard'
}

export interface ReportGenerationDescription {
    code: string;
    label: string;
    generationType: ReportGenerationType;
}

export interface ReportGenerationOneShotConfiguration {
    period: number;
    enableEstimated: boolean;
    report: ReportGenerationDescription;
    classificationNodeId: ClassificationNodeId;
}
